
import { defineComponent } from 'vue'

import OwnerDetailMixin from '~/mixins/ownerDetailMixin'
import PlanDetailMixin from '~/mixins/planDetailMixin'

export default defineComponent({
  name: 'UpgradeAccountModal',
  mixins: [OwnerDetailMixin, PlanDetailMixin],
  props: {
    login: {
      type: String,
      required: true
    },
    provider: {
      type: String,
      required: true
    }
  },
  async fetch(): Promise<void> {
    const params = {
      login: this.login,
      provider: this.provider
    }

    const queries = [this.fetchBillingDetails(params), this.fetchUsageDetails(params)]

    if (!this.context.plans) {
      queries.push(this.fetchContext())
    }

    await Promise.all(queries)
  },

  computed: {
    maxFeatureUsage(): number | undefined {
      return this.owner.featureUsage?.find(
        ({ shortcode }: Record<string, unknown>) => shortcode === 'autofix'
      )?.max
    }
  }
})
